var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/* eslint-disable react-hooks/exhaustive-deps */
import React, { createContext, useCallback, useContext, useEffect, useMemo, useState, } from "react";
import { Requerimento } from "../../../../model/Requerimento";
import { TipoRequerenteReqEnum } from "../../../../model/enums/TipoRequerenteReqEnum";
import { TipoDocumentoEnum } from "../../../../model/enums/TipoDocumentoEnum";
import { AuthConstants } from "../../../../util/auth-constants";
import { TipoProcessoEnum } from "../../../../model/enums/TipoProcessoEnum";
import { HandleError } from "../../../utils/HandleError";
import { LocalStorageUtils } from "../../../../util/LocalStorageUtils";
import { RequerimentosApi } from "../../../../apis/requerimento-api";
import { useCacheStore } from "../../../../stores/CacheStore";
import { useNavigate, useParams } from "react-router-dom";
import { RequerimentoApi } from "../../../../apis/requerimentoAPi";
import { ParcelaImovel } from "../../../../model/ParcelaImovel";
import { ModoCRUDEnum } from "../../../../model/enums/ModoCRUDEnum";
import { normalizeCpf } from '../../../utils/documentoValidators';
import { TipoImovelEnum } from "../../../../model/enums/TipoImovelEnum";
import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, useMediaQuery, useTheme, } from "@mui/material";
import { Routes } from "../../../../routes/constants";
import { ShowContent } from "../../../../components/ShowContent";
import { TipoParcelaEnum } from "../../../../components/TipoParcelaEnum";
export var outrosOpt = { id: null, denominacao: "Outro", nome: "Outro" };
export var defaultMessageFieldError = "O campo deve ser informado.";
export var defaultMessageEmailError = "Por favor, insira um e-mail válido.";
export var defaultMessageParcelaError = "Ao menos uma parcela deve ser informada.";
export var defaultMessageFieldCpfError = "CPF inválido.";
export var flagCpfDuplicado = "CPF Duplicado:";
export var flagCpfPessoaFalecida = "CPF pertence a uma pessoa fisica falecida.";
export var prettyDistancia = function (distancia) {
    return distancia === null || distancia === void 0 ? void 0 : distancia.toFixed(2).replace(".", ",");
};
export var prettyVertice = function (vertice) {
    var letras = vertice === null || vertice === void 0 ? void 0 : vertice.slice(0, 3);
    var letra = vertice === null || vertice === void 0 ? void 0 : vertice.slice(3, 4);
    var numeros = vertice === null || vertice === void 0 ? void 0 : vertice.slice(4);
    return "".concat(letras, "-").concat(letra, "-").concat(numeros);
};
export var prettyCoordenadaGMS = function (coord) {
    var graus = coord === null || coord === void 0 ? void 0 : coord.slice(0, 2);
    var minutos = coord === null || coord === void 0 ? void 0 : coord.slice(2, 4);
    var segundosInteiros = coord === null || coord === void 0 ? void 0 : coord.slice(4, 6);
    var segundosDecimais = coord === null || coord === void 0 ? void 0 : coord.slice(6);
    return "".concat(graus, "\u00B0 ").concat(minutos, "' ").concat(segundosInteiros, ".").concat(segundosDecimais);
};
export var defaultParcela = __assign(__assign({}, new ParcelaImovel()), { municipioOrigem: undefined, municipio: undefined, responsavelTecnico: undefined, quadra: undefined, lote: undefined, livroFundiario: undefined, folhaLivroFundiario: undefined, orgaoResponsavel: undefined, tipo: TipoParcelaEnum.CONVENCIONAIS });
export var handleScrollTop = function () {
    setTimeout(function () {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, 500);
};
export var generateErrorFields = function (fields, old) {
    return fields.reduce(function (acc, _a) {
        var key = _a.key, condition = _a.condition;
        acc[key] = condition
            ? defaultMessageFieldError
            : verifyFieldError(key, old);
        return acc;
    }, __assign({}, old));
};
export var handleMountCondition = function (boolCondition, logicCondition) {
    if (boolCondition) {
        return logicCondition;
    }
    return false;
};
export var verifyFieldError = function (key, old) {
    if (key.startsWith("cpf")) {
        return verifyFieldErrorCpf(key, old);
    }
    else if (key.startsWith("email")) {
        return verifyFieldErrorEmail(key, old);
    }
    else {
        return "";
    }
};
export var verifyFieldErrorCpf = function (key, old) {
    return "".concat(old[key]).startsWith(defaultMessageFieldCpfError)
        ? "".concat(old[key])
        : verifyFieldErrorDocDuplicado(key, old);
};
export var verifyFieldErrorDocDuplicado = function (key, old) {
    return "".concat(old[key]).startsWith(flagCpfDuplicado) ? "".concat(old[key]) : "";
};
export var verifyFieldErrorEmail = function (key, old) {
    return "".concat(old[key]).startsWith(defaultMessageEmailError)
        ? "".concat(old[key])
        : "";
};
var RequerimentoContext = createContext(null);
export var RequerimentoProvider = function (_a) {
    //region Constants
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
    var children = _a.children;
    var navigate = useNavigate();
    var theme = useTheme();
    var fullScreen = useMediaQuery(theme.breakpoints.down("md"));
    var defaultParcela = __assign(__assign({}, new ParcelaImovel()), { municipioOrigem: undefined, municipio: undefined, responsavelTecnico: undefined, quadra: undefined, lote: undefined, livroFundiario: undefined, folhaLivroFundiario: undefined, orgaoResponsavel: undefined, matricula: undefined, area: undefined, tipo: TipoParcelaEnum.CONVENCIONAIS });
    var _u = useState(TipoRequerenteReqEnum.REQUERENTE), tipoRequerente = _u[0], setTipoRequerente = _u[1];
    var _v = useState(TipoProcessoEnum.REGULARIZACAO_RURAL), tipoServico = _v[0], setTipoServico = _v[1];
    var _w = useState(TipoDocumentoEnum.PF), tipoRequerenteDoc = _w[0], setTipoRequerenteDoc = _w[1];
    var _x = useState(false), procuradorInventariante = _x[0], setProcuradorInventariante = _x[1];
    var _y = useState(false), indicarProcurador = _y[0], setIndicarProcurador = _y[1];
    var _z = useState(new Requerimento()), requerimento = _z[0], setRequerimento = _z[1];
    var _0 = useState(false), loadingSubmit = _0[0], setLoadingSubmit = _0[1];
    var _1 = useState(false), openToSubmit = _1[0], setOpenToSubmit = _1[1];
    var _2 = useState(false), openSuccess = _2[0], setOpenSuccess = _2[1];
    var _3 = useState(true), isLoadingForm = _3[0], setIsLoadingForm = _3[1];
    var _4 = useState(0), activeStep = _4[0], setActiveStep = _4[1];
    var _5 = useState(), error = _5[0], setError = _5[1];
    var id = useParams().id;
    var _6 = useState(function () { return function () { return false; }; }), validationStepOne = _6[0], setValidationStepOne = _6[1];
    var _7 = useState(function () { return function () { return false; }; }), validationStepTwo = _7[0], setValidationStepTwo = _7[1];
    var _8 = useState(function () { return function () { return false; }; }), validationStepThree = _8[0], setValidationStepThree = _8[1];
    var _9 = useState(function () { return function () { return false; }; }), validationStepFour = _9[0], setValidationStepFour = _9[1];
    var _10 = useState(function () { return function () { return false; }; }), validationStepFive = _10[0], setValidationStepFive = _10[1];
    var _11 = useState({
        open: false,
        message: "",
        severity: "info",
    }), notification = _11[0], setNotification = _11[1];
    //endregion
    // region Hooks
    useEffect(function () { }, []);
    useEffect(function () {
        if (isLoadingForm)
            return;
        LocalStorageUtils.setEncryptedDataInLocalStorage(AuthConstants.REQUERIMENTO_CACHE, __assign({}, requerimento));
    }, [requerimento, isLoadingForm]);
    var requerentePossuiAdvogado = useMemo(function () {
        var _a;
        return ((_a = requerimento === null || requerimento === void 0 ? void 0 : requerimento.requerentePf) === null || _a === void 0 ? void 0 : _a.advogado) === true;
    }, [(_b = requerimento === null || requerimento === void 0 ? void 0 : requerimento.requerentePf) === null || _b === void 0 ? void 0 : _b.advogado]);
    useEffect(function () {
        if (id) {
            var _id_1 = Number(id);
            if (!isNaN(_id_1)) {
                setIsLoadingForm(true);
                RequerimentoApi.buscarPorId(_id_1)
                    .then(function (req) {
                    var _a, _b, _c;
                    var cacheStore = useCacheStore.getState();
                    var requerimentoCache = cacheStore.getCache(AuthConstants.REQUERIMENTO_CACHE);
                    if (requerimentoCache && (requerimentoCache === null || requerimentoCache === void 0 ? void 0 : requerimentoCache.id) !== _id_1) {
                        LocalStorageUtils.removeEncryptedDataFromLocalStorage(AuthConstants.REQUERIMENTO_CACHE);
                        cacheStore.removeCache(AuthConstants.REQUERIMENTO_CACHE);
                        setRequerimento(__assign({}, req));
                        var _tipoReq = (_a = req === null || req === void 0 ? void 0 : req.tipoRequerente) !== null && _a !== void 0 ? _a : TipoRequerenteReqEnum.REQUERENTE;
                        setTipoRequerente(_tipoReq);
                        var _tipoDoc = (_b = req === null || req === void 0 ? void 0 : req.tipoRequerimentoDoc) !== null && _b !== void 0 ? _b : TipoDocumentoEnum.PF;
                        setTipoRequerenteDoc(_tipoDoc);
                    }
                    setActiveStep((_c = req === null || req === void 0 ? void 0 : req.abaFormulario) !== null && _c !== void 0 ? _c : 0);
                })
                    .catch(function (error) { return setError(error); })
                    .finally(function () { return setIsLoadingForm(false); });
            }
            else {
                handleLoadData();
            }
        }
        else {
            handleLoadData();
        }
    }, [id]);
    useEffect(function () {
        var cacheStore = useCacheStore.getState();
        cacheStore.setCache(AuthConstants.REQUERIMENTO_CACHE, __assign({}, requerimento));
    }, [requerimento]);
    useEffect(function () {
        if (requerimento) {
            handleInitializeHeader(requerimento);
        }
    }, [requerimento === null || requerimento === void 0 ? void 0 : requerimento.servico]);
    var tipoRequerimento = useMemo(function () {
        var _a;
        return (_a = requerimento === null || requerimento === void 0 ? void 0 : requerimento.servico) === null || _a === void 0 ? void 0 : _a.referenciaServico;
    }, [(_c = requerimento === null || requerimento === void 0 ? void 0 : requerimento.servico) === null || _c === void 0 ? void 0 : _c.referenciaServico]);
    var invertido = useMemo(function () {
        return (tipoRequerimento === TipoProcessoEnum.DECLARACAO_ASSENTADO ||
            tipoRequerimento === TipoProcessoEnum.RATIFICACAO_TITULO_DEF_URBANO);
    }, [tipoRequerimento]);
    var isRequerimentoReguralizacaoFundiaria = useMemo(function () {
        var _a, _b, _c;
        return (((_a = requerimento === null || requerimento === void 0 ? void 0 : requerimento.servico) === null || _a === void 0 ? void 0 : _a.referenciaServico) ===
            TipoProcessoEnum.REGULARIZACAO_RURAL ||
            ((_b = requerimento === null || requerimento === void 0 ? void 0 : requerimento.servico) === null || _b === void 0 ? void 0 : _b.referenciaServico) ===
                TipoProcessoEnum.REGULARIZACAO_FUND_RURAL_ASSENTAMENTO ||
            ((_c = requerimento === null || requerimento === void 0 ? void 0 : requerimento.servico) === null || _c === void 0 ? void 0 : _c.referenciaServico) ===
                TipoProcessoEnum.REGULARIZACAO_FUNDIARIA_URBANA);
    }, [(_d = requerimento === null || requerimento === void 0 ? void 0 : requerimento.servico) === null || _d === void 0 ? void 0 : _d.referenciaServico]);
    var requerimentoCpfReferences = useMemo(function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
        return [
            {
                cpf: (_c = (_b = (_a = requerimento === null || requerimento === void 0 ? void 0 : requerimento.requerentePj) === null || _a === void 0 ? void 0 : _a.representante) === null || _b === void 0 ? void 0 : _b.conjuge) === null || _c === void 0 ? void 0 : _c.cpf,
                profile: "CONJUGE_REPRESENTANTE",
                message: "Este CPF já se encontra em uso pelo Conjuge do Representante Legal.",
            },
            {
                cpf: (_e = (_d = requerimento === null || requerimento === void 0 ? void 0 : requerimento.requerimentoInventariante) === null || _d === void 0 ? void 0 : _d.pessoaFalecida) === null || _e === void 0 ? void 0 : _e.cpf,
                profile: "PESSOA_FALECIDA",
                message: "Este CPF já se encontra em uso pela Pessoa Falecida.",
            },
            {
                cpf: (_g = (_f = requerimento === null || requerimento === void 0 ? void 0 : requerimento.requerimentoInventariante) === null || _f === void 0 ? void 0 : _f.inventariante) === null || _g === void 0 ? void 0 : _g.cpf,
                profile: "INVENTERIANTE",
                message: "Este CPF já se encontra em uso pelo Inventariante.",
            },
            {
                cpf: (_j = (_h = requerimento === null || requerimento === void 0 ? void 0 : requerimento.requerentePj) === null || _h === void 0 ? void 0 : _h.representante) === null || _j === void 0 ? void 0 : _j.cpf,
                profile: "REPRESENTANTE",
                message: "Este CPF já se encontra em uso pelo Representante Legal.",
            },
            {
                cpf: (_l = (_k = requerimento === null || requerimento === void 0 ? void 0 : requerimento.requerentePf) === null || _k === void 0 ? void 0 : _k.conjuge) === null || _l === void 0 ? void 0 : _l.cpf,
                profile: "CONJUGE_REQUERENTE",
                message: "Este CPF já se encontra em uso pelo Conjuge do Requerente.",
            },
            {
                cpf: (_o = (_m = requerimento === null || requerimento === void 0 ? void 0 : requerimento.procurador) === null || _m === void 0 ? void 0 : _m.pessoaFisica) === null || _o === void 0 ? void 0 : _o.cpf,
                profile: "PROCURADOR",
                message: "Este CPF já se encontra em uso pelo Procurador.",
            },
            {
                cpf: (_p = requerimento === null || requerimento === void 0 ? void 0 : requerimento.requerentePf) === null || _p === void 0 ? void 0 : _p.cpf,
                profile: "REQUERENTE",
                message: "Este CPF já se encontra em uso pelo Requerente.",
            },
        ];
    }, [
        (_f = (_e = requerimento === null || requerimento === void 0 ? void 0 : requerimento.requerimentoInventariante) === null || _e === void 0 ? void 0 : _e.pessoaFalecida) === null || _f === void 0 ? void 0 : _f.cpf,
        (_h = (_g = requerimento === null || requerimento === void 0 ? void 0 : requerimento.requerimentoInventariante) === null || _g === void 0 ? void 0 : _g.inventariante) === null || _h === void 0 ? void 0 : _h.cpf,
        (_l = (_k = (_j = requerimento === null || requerimento === void 0 ? void 0 : requerimento.requerentePj) === null || _j === void 0 ? void 0 : _j.representante) === null || _k === void 0 ? void 0 : _k.conjuge) === null || _l === void 0 ? void 0 : _l.cpf,
        (_o = (_m = requerimento === null || requerimento === void 0 ? void 0 : requerimento.requerentePj) === null || _m === void 0 ? void 0 : _m.representante) === null || _o === void 0 ? void 0 : _o.cpf,
        (_q = (_p = requerimento === null || requerimento === void 0 ? void 0 : requerimento.procurador) === null || _p === void 0 ? void 0 : _p.pessoaFisica) === null || _q === void 0 ? void 0 : _q.cpf,
        (_s = (_r = requerimento === null || requerimento === void 0 ? void 0 : requerimento.requerentePf) === null || _r === void 0 ? void 0 : _r.conjuge) === null || _s === void 0 ? void 0 : _s.cpf,
        (_t = requerimento === null || requerimento === void 0 ? void 0 : requerimento.requerentePf) === null || _t === void 0 ? void 0 : _t.cpf,
    ]);
    var verifyTipReq = useCallback(function (tipoReq) {
        return tipoRequerente === tipoReq;
    }, [tipoRequerente]);
    var verifyTipDoc = useCallback(function (tipoDoc) {
        return tipoRequerenteDoc === tipoDoc;
    }, [tipoRequerenteDoc]);
    var verifyTipProc = useCallback(function (tipoSerc) {
        var _a;
        return ((_a = requerimento === null || requerimento === void 0 ? void 0 : requerimento.servico) === null || _a === void 0 ? void 0 : _a.referenciaServico) === tipoSerc;
    }, [requerimento === null || requerimento === void 0 ? void 0 : requerimento.servico]);
    //endregion
    // region Handles
    var handleLoadData = function () {
        try {
            setIsLoadingForm(true);
            getLocalStorageData();
        }
        finally {
            setIsLoadingForm(false);
        }
    };
    var handleCloseError = function () {
        setError(undefined);
    };
    var recoverData = function (requerimento, setValue, path) {
        var valueCache = LocalStorageUtils.getEncryptedDataFromLocalStorage(path);
        var equalReq = (valueCache === null || valueCache === void 0 ? void 0 : valueCache.requerimentoId) === (requerimento === null || requerimento === void 0 ? void 0 : requerimento.id);
        if (!!valueCache && equalReq) {
            setValue(__assign({}, valueCache));
        }
    };
    var getLocalStorageData = function () { return __awaiter(void 0, void 0, Promise, function () {
        var requerimentoCache, _tipoDoc, _tipoReq;
        var _a, _b;
        return __generator(this, function (_c) {
            requerimentoCache = LocalStorageUtils.getEncryptedDataFromLocalStorage(AuthConstants.REQUERIMENTO_CACHE);
            if (requerimentoCache) {
                setRequerimento(__assign({}, requerimentoCache));
                _tipoDoc = (_a = requerimentoCache === null || requerimentoCache === void 0 ? void 0 : requerimentoCache.tipoRequerimentoDoc) !== null && _a !== void 0 ? _a : TipoDocumentoEnum.PF;
                _tipoReq = (_b = requerimentoCache === null || requerimentoCache === void 0 ? void 0 : requerimentoCache.tipoRequerente) !== null && _b !== void 0 ? _b : TipoRequerenteReqEnum.REQUERENTE;
                setTipoRequerenteDoc(_tipoDoc);
                setTipoRequerente(_tipoReq);
                if (requerimentoCache.procurador) {
                    setIndicarProcurador(true);
                }
            }
            return [2 /*return*/];
        });
    }); };
    var getStatusSigef = function (parcela, sigefIsOnline, usarApiSigef) {
        if (usarApiSigef === false)
            return "";
        var temCodigoSigef = !!(parcela === null || parcela === void 0 ? void 0 : parcela.codigoSIGEF);
        if (temCodigoSigef && sigefIsOnline) {
            return "✅ VALIDADO";
        }
        else if (temCodigoSigef && !sigefIsOnline) {
            return "🔄 VALIDADO (API OFFLINE)";
        }
        else if (!temCodigoSigef && !sigefIsOnline) {
            return "⏳ PENDENTE (INSERIDO OFFLINE)";
        }
        else {
            return "❌ PENDENTE (REQUER VALIDAÇÃO)";
        }
    };
    var handleBack = function () {
        if (activeStep > 0) {
            setActiveStep(function (prevStep) { return prevStep - 1; });
        }
    };
    var hasCpfDuplicates = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
        var collected = [];
        var addCpf = function (cpf) {
            if (!cpf)
                return;
            var digits = normalizeCpf("".concat(cpf));
            if (digits)
                collected.push(digits);
        };
        addCpf((_a = requerimento === null || requerimento === void 0 ? void 0 : requerimento.requerentePf) === null || _a === void 0 ? void 0 : _a.cpf);
        addCpf((_c = (_b = requerimento === null || requerimento === void 0 ? void 0 : requerimento.requerentePf) === null || _b === void 0 ? void 0 : _b.conjuge) === null || _c === void 0 ? void 0 : _c.cpf);
        addCpf((_e = (_d = requerimento === null || requerimento === void 0 ? void 0 : requerimento.requerimentoInventariante) === null || _d === void 0 ? void 0 : _d.inventariante) === null || _e === void 0 ? void 0 : _e.cpf);
        addCpf((_g = (_f = requerimento === null || requerimento === void 0 ? void 0 : requerimento.requerimentoInventariante) === null || _f === void 0 ? void 0 : _f.pessoaFalecida) === null || _g === void 0 ? void 0 : _g.cpf);
        addCpf((_j = (_h = requerimento === null || requerimento === void 0 ? void 0 : requerimento.procurador) === null || _h === void 0 ? void 0 : _h.pessoaFisica) === null || _j === void 0 ? void 0 : _j.cpf);
        addCpf((_l = (_k = requerimento === null || requerimento === void 0 ? void 0 : requerimento.requerentePj) === null || _k === void 0 ? void 0 : _k.representante) === null || _l === void 0 ? void 0 : _l.cpf);
        addCpf((_p = (_o = (_m = requerimento === null || requerimento === void 0 ? void 0 : requerimento.requerentePj) === null || _m === void 0 ? void 0 : _m.representante) === null || _o === void 0 ? void 0 : _o.conjuge) === null || _p === void 0 ? void 0 : _p.cpf);
        var counts = collected.reduce(function (acc, cur) {
            acc[cur] = (acc[cur] || 0) + 1;
            return acc;
        }, {});
        var hasDup = Object.values(counts).some(function (c) { return c > 1; });
        if (hasDup) {
            setNotification({
                open: true,
                message: "Existe CPF duplicado no formulário. Corrija os CPFs marcados em vermelho antes de avançar.",
                severity: "error",
                duration: 4000,
                vertical: "top",
            });
        }
        return hasDup;
    };
    var isProcessoTitle = useMemo(function () {
        return (tipoRequerimento === TipoProcessoEnum.CERTIDAO_ADMINISTRATIVA ||
            tipoRequerimento === TipoProcessoEnum.SOLICITAR_CARGA_COPIA_DIGITALIZADA);
    }, [tipoRequerimento]);
    var _steps = useMemo(function () {
        var firstLabel = tipoRequerimento === TipoProcessoEnum.REGULARIZACAO_FUNDIARIA_URBANA
            ? "Inserir Dados do Requerimento"
            : "Inserir Dados do Requerente";
        var stepTwoLabel = "Inserir Dados do Imóvel";
        if (tipoRequerimento === TipoProcessoEnum.BUSCA_PESQUISA) {
            stepTwoLabel = "Inserir Dados da Busca";
        }
        else if (isProcessoTitle) {
            stepTwoLabel = "Inserir Dados do Processo";
        }
        var step = invertido
            ? [stepTwoLabel, firstLabel]
            : [firstLabel, stepTwoLabel];
        return __spreadArray(__spreadArray([], step, true), ["Subir Anexos", "Confirmar Dados", "Confirmar Anexos"], false);
    }, [invertido, tipoRequerimento, isProcessoTitle]);
    var defaultHandleAddParcelaImovel = function (_a) {
        var _b = _a.defaultBaseValue, defaultBaseValue = _b === void 0 ? defaultParcela : _b, _c = _a.tipoParcela, tipoParcela = _c === void 0 ? "PARCELA_IMOVEL" : _c, _d = _a.disableState, disableState = _d === void 0 ? [null, null] : _d, _e = _a.field, field = _e === void 0 ? "parcelasImovel" : _e, indexSelecionadoState = _a.indexSelecionadoState, _f = _a.sigefIsOnline, sigefIsOnline = _f === void 0 ? false : _f, _g = _a.showMessage, showMessage = _g === void 0 ? true : _g, requerimentoState = _a.requerimentoState, _h = _a.clearRt, clearRt = _h === void 0 ? false : _h, fieldErrorState = _a.fieldErrorState, valueState = _a.valueState, modoState = _a.modoState, valido = _a.valido;
        if (valido) {
            defaultHandleAddParcelaImovelValid({
                defaultBaseValue: defaultBaseValue,
                field: field,
                indexSelecionadoState: indexSelecionadoState,
                requerimentoState: requerimentoState,
                valueState: valueState,
                modoState: modoState,
                valido: valido,
                fieldErrorState: fieldErrorState,
                disableState: disableState,
                sigefIsOnline: sigefIsOnline,
                clearRt: clearRt,
                showMessage: showMessage,
            });
        }
    };
    var defaultHandleAddParcelaImovelValid = function (_a) {
        var _b, _c;
        var _d, _e;
        var _f = _a.defaultBaseValue, defaultBaseValue = _f === void 0 ? defaultParcela : _f, _g = _a.tipoParcela, tipoParcela = _g === void 0 ? "PARCELA_IMOVEL" : _g, _h = _a.disableState, disableState = _h === void 0 ? [null, null] : _h, _j = _a.field, field = _j === void 0 ? "parcelasImovel" : _j, indexSelecionadoState = _a.indexSelecionadoState, _k = _a.sigefIsOnline, sigefIsOnline = _k === void 0 ? false : _k, _l = _a.showMessage, showMessage = _l === void 0 ? true : _l, requerimentoState = _a.requerimentoState, fieldErrorState = _a.fieldErrorState, _m = _a.clearRt, clearRt = _m === void 0 ? false : _m, valueState = _a.valueState, modoState = _a.modoState;
        var _o = fieldErrorState !== null && fieldErrorState !== void 0 ? fieldErrorState : [{}, function () { }], fieldError = _o[0], setFieldError = _o[1];
        var indexSelecionado = indexSelecionadoState[0], setIndexSelecionado = indexSelecionadoState[1];
        var isDisabledBySigef = disableState[0], setIsDisabledBySigef = disableState[1];
        var requerimento = requerimentoState[0], setRequerimento = requerimentoState[1];
        var value = valueState[0], setValue = valueState[1];
        var modo = modoState[0], setModo = modoState[1];
        var key = field;
        var hasSigefField = !!(value === null || value === void 0 ? void 0 : value.codigoSIGEF);
        var _p = handleValidateEqualParcela(requerimento, key, value, indexSelecionado, hasSigefField), hasSomeEqualParcela = _p[0], comparableFields = _p[1];
        if (hasSomeEqualParcela) {
            var message = "";
            switch (tipoParcela) {
                case "PARCELA_IMOVEL":
                    message = "Parcela de imóvel";
                    break;
                case "DADO_IMV":
                    message = "Parcela de imóvel concedido";
                    break;
                default:
                    message = "Dados imóvel";
                    break;
            }
            setNotification({
                message: "N\u00E3o \u00E9 permitido inserir duas vezes a mesma ".concat(message, "."),
                severity: "error",
                open: true,
                duration: 3000,
                vertical: "top",
            });
            var updatedFieldError_1 = __assign({}, fieldError);
            comparableFields.forEach(function (field) {
                updatedFieldError_1["".concat(field.field, "Error")] = field.duplicate
                    ? "Não é permitido inserir duas vezes a mesma parcela/imóvel."
                    : "";
            });
            setFieldError(updatedFieldError_1);
            return;
        }
        if (modo === ModoCRUDEnum.CREATE) {
            setRequerimento === null || setRequerimento === void 0 ? void 0 : setRequerimento(__assign(__assign({}, requerimento), (_b = {}, _b["".concat(key)] = __spreadArray(__spreadArray([], ((_d = requerimento === null || requerimento === void 0 ? void 0 : requerimento[key]) !== null && _d !== void 0 ? _d : []), true), [value], false), _b)));
            if (hasSigefField && isDisabledBySigef !== null) {
                setIsDisabledBySigef === null || setIsDisabledBySigef === void 0 ? void 0 : setIsDisabledBySigef(true);
            }
        }
        else if (modo === ModoCRUDEnum.UPDATE) {
            var parcelas = (_e = requerimento === null || requerimento === void 0 ? void 0 : requerimento[key]) === null || _e === void 0 ? void 0 : _e.map(function (it, index) { return (index === indexSelecionado ? value : it); });
            setRequerimento === null || setRequerimento === void 0 ? void 0 : setRequerimento(__assign(__assign({}, requerimento), (_c = {}, _c["".concat(key)] = __spreadArray([], parcelas, true), _c)));
        }
        var responsavelTecnico = null;
        if (!clearRt) {
            responsavelTecnico =
                modo === ModoCRUDEnum.CREATE ? __assign({}, value === null || value === void 0 ? void 0 : value.responsavelTecnico) : null;
        }
        if (sigefIsOnline && responsavelTecnico !== null) {
            responsavelTecnico = null;
        }
        if (showMessage) {
            setNotification({
                message: "Parcela inserida com sucesso!",
                severity: "success",
                open: true,
                duration: 3000,
                vertical: "top",
            });
        }
        setValue(__assign(__assign({}, defaultBaseValue), { tipoImovel: TipoImovelEnum.RURAL, responsavelTecnico: responsavelTecnico }));
        setModo(ModoCRUDEnum.CREATE);
        setIndexSelecionado(null);
    };
    var handleValidateEqualParcela = function (requerimento, key, value, indexSelecionado, hasSigefField) {
        var _a;
        var parcelas = ((_a = requerimento === null || requerimento === void 0 ? void 0 : requerimento[key]) !== null && _a !== void 0 ? _a : []);
        var fieldsToCompare = ["denominacao"];
        if (hasSigefField)
            fieldsToCompare.push("codigoSIGEF");
        var fieldsDuplicates = fieldsToCompare.map(function (campo) {
            var isDuplicate = parcelas.some(function (parcela, index) {
                if (indexSelecionado != null && index === indexSelecionado)
                    return false;
                return ("".concat(parcela === null || parcela === void 0 ? void 0 : parcela[campo]).toUpperCase() ===
                    "".concat(value[campo]).toUpperCase());
            });
            return {
                field: campo,
                duplicate: isDuplicate,
            };
        });
        var hasSomeEqualParcela = fieldsDuplicates.some(function (f) { return f.duplicate; });
        return [hasSomeEqualParcela, fieldsDuplicates];
    };
    var handleInitializeHeader = function (cache) {
        var _a, _b;
        var _header = document.getElementById("HEADER_NAME");
        if (_header) {
            var newHeader = "Requerimento ";
            if (!id || "".concat(cache.id) === id) {
                newHeader = "".concat(newHeader, " ").concat((_b = (_a = cache === null || cache === void 0 ? void 0 : cache.servico) === null || _a === void 0 ? void 0 : _a.nomeReqServico) !== null && _b !== void 0 ? _b : "");
            }
            _header.innerText = newHeader;
        }
    };
    var handleNextStep = function (e) {
        e === null || e === void 0 ? void 0 : e.preventDefault();
        if (hasCpfDuplicates()) {
            return;
        }
        switch (activeStep) {
            case 0:
                if (validationStepOne()) {
                    handleSubmitStepOne();
                    handleScrollTop();
                }
                break;
            case 1:
                if (validationStepTwo()) {
                    handleSubmitStepTwo();
                    handleScrollTop();
                }
                break;
            case 2:
                if (validationStepThree()) {
                    handleSubmitStepThree();
                    handleScrollTop();
                    return;
                }
                break;
            case 3:
                if (validationStepFour()) {
                    handleSubmitStepFour();
                    handleScrollTop();
                    return;
                }
                break;
            case 4:
                if (validationStepFive()) {
                    setOpenToSubmit(true);
                    return;
                }
                break;
            default:
                setError({
                    error: { response: { data: { message: "Etapa Inválida" } } },
                });
                setActiveStep(0);
                break;
        }
    };
    var handleConfirmSubmit = function () { return __awaiter(void 0, void 0, Promise, function () {
        return __generator(this, function (_a) {
            handleSubmitStepFive();
            return [2 /*return*/];
        });
    }); };
    var handlePreRequest = function () {
        setLoadingSubmit(true);
        setNotification({
            open: true,
            message: "Requerimento salvo com sucesso!",
            severity: "success",
            duration: 6000,
            vertical: "top",
        });
    };
    var handleSubmitStepOne = function () {
        try {
            var req = handlePreparedRequest();
            handlePreRequest();
            RequerimentoApi.cadastroBasico(req)
                .then(function (_requerimento) {
                setRequerimento(__assign({}, _requerimento));
                if (!id) {
                    navigate("".concat(Routes.REQUERIMENTO_EDITAR.path, "/").concat(_requerimento === null || _requerimento === void 0 ? void 0 : _requerimento.id));
                }
                else {
                    setActiveStep(function (prevActiveStep) { return prevActiveStep + 1; });
                }
                setNotification({
                    open: true,
                    message: "Seus dados foram salvos em rascunho!",
                    severity: "success",
                    duration: 6000,
                    vertical: "top",
                });
            })
                .catch(function (error) { return setError(error); })
                .finally(function () { return setLoadingSubmit(false); });
        }
        catch (e) {
            setLoadingSubmit(false);
            console.error(e);
            setError(e);
        }
    };
    // Etapa de dados do imóvel do Requerimento
    var handleSubmitStepTwo = function () {
        try {
            var req = handlePreparedRequest();
            handlePreRequest();
            RequerimentoApi.dadosImovel(req)
                .then(function (_requerimento) {
                setRequerimento(__assign({}, _requerimento));
                setActiveStep(function (prevActiveStep) { return prevActiveStep + 1; });
                var cacheStore = useCacheStore.getState();
                cacheStore.removeCache(AuthConstants.DADOS_CARTOGRAFICOS_LIMITROFES_CACHE);
                cacheStore.removeCache(AuthConstants.PARCELA_IMOVEL_CONCEDIDO_CACHE);
                cacheStore.removeCache(AuthConstants.PARCELA_IMOVEL_CACHE);
                setNotification({
                    open: true,
                    message: "Seus dados foram salvos em rascunho!",
                    severity: "success",
                    duration: 6000,
                    vertical: "top",
                });
            })
                .catch(function (error) { return setError(error); })
                .finally(function () { return setLoadingSubmit(false); });
        }
        catch (e) {
            setLoadingSubmit(false);
            console.error(e);
            setError(e);
        }
    };
    // Etapa de Anexos do Requerimento
    var handleSubmitStepThree = function () {
        try {
            var req = handlePreparedRequest();
            handlePreRequest();
            RequerimentoApi.dadosAnexos(req)
                .then(function (_requerimento) {
                setRequerimento(__assign({}, _requerimento));
                setActiveStep(function (prevActiveStep) { return prevActiveStep + 1; });
                setNotification({
                    open: true,
                    message: "Seus dados foram salvos em rascunho!",
                    severity: "success",
                    duration: 6000,
                    vertical: "top",
                });
            })
                .catch(function (error) { return setError(error); })
                .finally(function () { return setLoadingSubmit(false); });
        }
        catch (e) {
            setLoadingSubmit(false);
            console.error(e);
            setError(e);
        }
    };
    // Etapa de confirmação de dados do Requerimento
    var handleSubmitStepFour = function () {
        try {
            handlePreRequest();
            RequerimentosApi.confirmacaoDados(requerimento === null || requerimento === void 0 ? void 0 : requerimento.id)
                .then(function (_requerimento) {
                setRequerimento(__assign({}, _requerimento));
                setActiveStep(function (prevActiveStep) { return prevActiveStep + 1; });
                setNotification({
                    open: true,
                    message: "Seus dados foram salvos com sucesso.",
                    severity: "success",
                    duration: 6000,
                    vertical: "top",
                });
            })
                .catch(function (error) { return setError(error); })
                .finally(function () { return setLoadingSubmit(false); });
        }
        catch (e) {
            setLoadingSubmit(false);
            console.error(e);
            setError(e);
        }
    };
    // Etapa de conclusão do Requerimento
    var handleSubmitStepFive = function () { return __awaiter(void 0, void 0, Promise, function () {
        return __generator(this, function (_a) {
            try {
                handlePreRequest();
                setLoadingSubmit(true);
                RequerimentosApi.concluir(requerimento === null || requerimento === void 0 ? void 0 : requerimento.id)
                    .then(function (response) {
                    var cacheStore = useCacheStore.getState();
                    cacheStore.removeCache(AuthConstants.INDEX_ANEXOS_VIEWED);
                    cacheStore.removeCache(AuthConstants.REQUERIMENTO_CACHE);
                    setOpenSuccess(true);
                })
                    .catch(function (error) { return setError(error); })
                    .finally(function () { return setLoadingSubmit(false); });
            }
            catch (e) {
                console.error(e);
                setError(e);
            }
            finally {
                setLoadingSubmit(false);
            }
            return [2 /*return*/];
        });
    }); };
    //endregion
    var handlePreparedRequest = function () {
        var _a, _b;
        var step = activeStep + 1;
        return __assign(__assign({}, requerimento), { tipoRequerimento: ((_a = requerimento === null || requerimento === void 0 ? void 0 : requerimento.tipoRequerimento) === null || _a === void 0 ? void 0 : _a.idTipoRequerimento)
                ? __assign({}, requerimento === null || requerimento === void 0 ? void 0 : requerimento.tipoRequerimento) : null, checklist: ((_b = requerimento === null || requerimento === void 0 ? void 0 : requerimento.checklist) === null || _b === void 0 ? void 0 : _b.id)
                ? __assign({}, requerimento === null || requerimento === void 0 ? void 0 : requerimento.checklist) : null, requerentePf: handleVerificaRequerentePf(requerimento === null || requerimento === void 0 ? void 0 : requerimento.requerentePf), parcelasImovelConcedido: (requerimento === null || requerimento === void 0 ? void 0 : requerimento.parcelasImovelConcedido) || [], parcelasImovel: (requerimento === null || requerimento === void 0 ? void 0 : requerimento.parcelasImovel) || [], requerimentoInventariante: handleVerificaInventariante(), requerentePj: handleVerificaRequerentePj(), procurador: handleVerificaProcurador(), abaFormulario: step <= 4 ? step : 0 });
    };
    var handleVerificaProcurador = function () {
        var _a;
        var pessoaFisica = handleVerificaRequerentePf((_a = requerimento === null || requerimento === void 0 ? void 0 : requerimento.procurador) === null || _a === void 0 ? void 0 : _a.pessoaFisica);
        return (pessoaFisica === null || pessoaFisica === void 0 ? void 0 : pessoaFisica.cpf)
            ? __assign(__assign({}, requerimento === null || requerimento === void 0 ? void 0 : requerimento.procurador), { pessoaFisica: pessoaFisica }) : null;
    };
    var handleVerificaInventariante = function () {
        var _a, _b;
        var pessoaFalecida = handleVerificaRequerentePf((_a = requerimento === null || requerimento === void 0 ? void 0 : requerimento.requerimentoInventariante) === null || _a === void 0 ? void 0 : _a.pessoaFalecida);
        var inventariante = handleVerificaRequerentePf((_b = requerimento === null || requerimento === void 0 ? void 0 : requerimento.requerimentoInventariante) === null || _b === void 0 ? void 0 : _b.inventariante);
        return !!pessoaFalecida && !!inventariante
            ? __assign(__assign({}, requerimento === null || requerimento === void 0 ? void 0 : requerimento.requerimentoInventariante), { pessoaFalecida: pessoaFalecida, inventariante: inventariante }) : null;
    };
    var handleVerificaRequerentePj = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        var conjugeRepresentante = ((_c = (_b = (_a = requerimento === null || requerimento === void 0 ? void 0 : requerimento.requerentePj) === null || _a === void 0 ? void 0 : _a.representante) === null || _b === void 0 ? void 0 : _b.conjuge) === null || _c === void 0 ? void 0 : _c.cpf)
            ? __assign({}, (_e = (_d = requerimento === null || requerimento === void 0 ? void 0 : requerimento.requerentePj) === null || _d === void 0 ? void 0 : _d.representante) === null || _e === void 0 ? void 0 : _e.conjuge) : undefined;
        var representante = ((_g = (_f = requerimento === null || requerimento === void 0 ? void 0 : requerimento.requerentePj) === null || _f === void 0 ? void 0 : _f.representante) === null || _g === void 0 ? void 0 : _g.cpf)
            ? __assign(__assign({}, (_h = requerimento === null || requerimento === void 0 ? void 0 : requerimento.requerentePj) === null || _h === void 0 ? void 0 : _h.representante), { conjuge: conjugeRepresentante }) : undefined;
        return ((_j = requerimento === null || requerimento === void 0 ? void 0 : requerimento.requerentePj) === null || _j === void 0 ? void 0 : _j.cnpj)
            ? __assign(__assign({}, requerimento === null || requerimento === void 0 ? void 0 : requerimento.requerentePj), { representante: __assign({}, representante) }) : undefined;
    };
    var handleVerificaRequerentePf = function (requerentePf) {
        var _a;
        var conjugeRequerente = ((_a = requerentePf === null || requerentePf === void 0 ? void 0 : requerentePf.conjuge) === null || _a === void 0 ? void 0 : _a.cpf)
            ? __assign({}, requerentePf === null || requerentePf === void 0 ? void 0 : requerentePf.conjuge) : null;
        return (requerentePf === null || requerentePf === void 0 ? void 0 : requerentePf.cpf)
            ? __assign(__assign({}, requerentePf), { conjuge: conjugeRequerente }) : null;
    };
    var handleListar = function () {
        navigate("".concat(Routes.REQUERIMENTO_LISTAR.path));
    };
    var handleEmitirTaxa = function () {
        navigate("".concat(Routes.REQUERIMENTO_EMITIR_TAXAS.path, "/") + requerimento.id);
    };
    //endregion
    var contextValue = useMemo(function () { return ({
        procuradorInventariante: procuradorInventariante,
        setProcuradorInventariante: setProcuradorInventariante,
        tipoRequerenteDoc: tipoRequerenteDoc,
        setTipoRequerenteDoc: setTipoRequerenteDoc,
        tipoRequerente: tipoRequerente,
        setTipoRequerente: setTipoRequerente,
        indicarProcurador: indicarProcurador,
        setIndicarProcurador: setIndicarProcurador,
        defaultHandleAddParcelaImovel: defaultHandleAddParcelaImovel,
        getStatusSigef: getStatusSigef,
        handleNextStep: handleNextStep,
        activeStep: activeStep,
        setActiveStep: setActiveStep,
        loadingSubmit: loadingSubmit,
        _steps: _steps,
        recoverData: recoverData,
        setLoadingSubmit: setLoadingSubmit,
        notification: notification,
        setNotification: setNotification,
        tipoServico: tipoServico,
        setTipoServico: setTipoServico,
        tipoRequerimento: tipoRequerimento,
        isLoadingForm: isLoadingForm,
        setIsLoadingForm: setIsLoadingForm,
        handleBack: handleBack,
        verifyTipReq: verifyTipReq,
        verifyTipDoc: verifyTipDoc,
        verifyTipProc: verifyTipProc,
        invertido: invertido,
        isRequerimentoReguralizacaoFundiaria: isRequerimentoReguralizacaoFundiaria,
        requerentePossuiAdvogado: requerentePossuiAdvogado,
        requerimentoCpfReferences: requerimentoCpfReferences,
        defaultParcela: defaultParcela,
        _requerimento: [requerimento, setRequerimento],
        validStepOne: [validationStepOne, setValidationStepOne],
        validStepTwo: [validationStepTwo, setValidationStepTwo],
        validStepThree: [validationStepThree, setValidationStepThree],
        validStepFour: [validationStepFour, setValidationStepFour],
        validStepFive: [validationStepFive, setValidationStepFive],
    }); }, [
        requerimento,
        procuradorInventariante,
        setProcuradorInventariante,
        setRequerimento,
        tipoRequerente,
        setTipoRequerente,
        indicarProcurador,
        setIndicarProcurador,
        activeStep,
        setActiveStep,
        loadingSubmit,
        setLoadingSubmit,
        notification,
        _steps,
        setNotification,
        tipoServico,
        setTipoServico,
        isLoadingForm,
        setIsLoadingForm,
        validationStepOne,
        validationStepTwo,
        validationStepThree,
        tipoRequerenteDoc,
        setTipoRequerenteDoc,
        validationStepFour,
        validationStepFive,
        tipoRequerimento,
        invertido,
        verifyTipReq,
        verifyTipDoc,
        verifyTipProc,
        isRequerimentoReguralizacaoFundiaria,
        requerentePossuiAdvogado,
        defaultParcela,
    ]);
    return (_jsx(RequerimentoContext.Provider, __assign({ value: contextValue }, { children: _jsxs(_Fragment, { children: [children, _jsxs(Dialog, __assign({ fullScreen: fullScreen, open: openToSubmit, onClose: function () { return setOpenToSubmit(false); }, "aria-labelledby": "responsive-dialog-title" }, { children: [_jsx(DialogTitle, __assign({ id: "responsive-dialog-title" }, { children: "Confirmação de Salvamento" })), _jsx(DialogContent, { children: _jsx(DialogContentText, { children: "Se todos os dados estiverem corretos, clique em \"Confirmar\" para salvar. Se precisar editar algum dado, clique em \"Voltar\"." }) }), _jsxs(DialogActions, { children: [_jsx(Button, __assign({ onClick: function () { return setOpenToSubmit(false); }, disabled: loadingSubmit }, { children: "Voltar" })), _jsxs(Button, __assign({ onClick: handleConfirmSubmit, disabled: loadingSubmit }, { children: ["Confirmar", _jsx(ShowContent, __assign({ show: loadingSubmit }, { children: _jsx(CircularProgress, { size: 20 }) }))] }))] })] })), _jsxs(Dialog, __assign({ fullScreen: fullScreen, open: openSuccess, onClose: function () { return setOpenSuccess(false); }, "aria-labelledby": "responsive-dialog-title" }, { children: [_jsx(DialogTitle, __assign({ id: "responsive-dialog-title" }, { children: "Gerar Taxas" })), _jsx(DialogContent, { children: _jsx(DialogContentText, { children: "Deseja gerar taxas para este servi\u00E7o?" }) }), _jsxs(DialogActions, { children: [_jsx(Button, __assign({ onClick: handleListar, disabled: loadingSubmit }, { children: "N\u00E3o" })), _jsx(Button, __assign({ autoFocus: true, onClick: handleEmitirTaxa, disabled: loadingSubmit }, { children: "Sim" }))] })] })), _jsx(HandleError, { error: error, handleClose: handleCloseError })] }) })));
};
export var useRequerimentoContext = function () {
    var context = useContext(RequerimentoContext);
    if (!context) {
        throw new Error("useRequerimentoContext deve ser usado dentro da tag RequerimentoProvider");
    }
    return context;
};
